import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import {
  cloneValue,
  expectObject,
  readOptionalNumber,
  readString,
  splitKnown,
} from "../utils";

export class ProductVersionSizeRecommendationBracketModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    percentage: { label: "Percentage", fieldType: "number", allowNull: true },
    size: { label: "Size", fieldType: "text" },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  percentage!: number | null;
  size!: string;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("percentage", null);
    this.defineObservableValue("size", "");
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(
      snapshot,
      "product size recommendation bracket"
    );
    this.percentage = readOptionalNumber(source, "percentage");
    this.size = readString(source, "size");
    this.extra = splitKnown(source, ["percentage", "size"]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.percentage === null ? {} : { percentage: this.percentage }),
      ...(this.size ? { size: this.size } : {}),
    };
  }
}
